import { Box, Stack } from '@mui/material';
import { GridColDef, DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getSalesByAM, IAnalyticsSalesByAccountManager } from 'wisestep-api';
import { Item, WsTypography, WsTypoVariants } from 'wisestep-base';

import { YearQuarterDropdown } from '../../../../../components';
import { IClientsAnalyticsChartsProps } from '../helper/payloadsAndTypesHelper';

const SalesByAMTable = ({ clientsAnalyticsChartsProps }: IClientsAnalyticsChartsProps) => {
  const paginationSize = 10;
  const [data, setData] = useState<IAnalyticsSalesByAccountManager[]>([]);
  const [selectedDate, setSelectedDate] = useState<string>(new Date().toString());
  useEffect(() => {
    const fetchData = async () => {
      const response = await getSalesByAM(clientsAnalyticsChartsProps.currency, selectedDate);
      setData(response.data);
    };
    fetchData();
  }, [clientsAnalyticsChartsProps, selectedDate]);

  const tableData = useMemo(() => {
    if (!data) return [];

    return data.map((item) => ({
      id: uuidv4(),
      am: item?.accountManager ? JSON.parse(item.accountManager)?.name : '',
      client: item.clientName,
      joinedCount: item.permJoinedCount,
      revenue: item.permJoinedRev?.toFixed(2),
      pendingJoin: Math.max(item.permOfferAcceptedCount - item.permJoinedCount, 0),
      estRevenue: item.permOfferAcceptedRev?.toFixed(2),
      totalCount: item.totalPermCount,
      totalAmount: item.totalPermRev?.toFixed(2),
    }));
  }, [data]);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'id', hide: true },
    { field: 'am', headerName: 'Account Manager', flex: 2 },
    {
      field: 'client',
      headerName: `Client`,
      flex: 2,
    },
    {
      headerName: 'Joined (Count)',
      field: `joinedCount`,
      flex: 2,
    },
    {
      headerName: 'Revenue (Amount)',
      field: `revenue`,
      flex: 2,
    },
    {
      headerName: 'Pending to join (Count)',
      field: `pendingJoin`,
      flex: 2,
    },
    {
      headerName: 'Estimated Revenue (Amount)',
      field: `estRevenue`,
      flex: 2,
    },
    {
      headerName: 'Total (Count)',
      field: `totalCount`,
      flex: 2,
    },
    {
      headerName: 'Total (Amount)',
      field: `totalAmount`,
      flex: 2,
    },
  ];

  return (
    <Box height="100%" width="100%">
      <Stack justifyContent="space-between" direction="row" alignItems="center">
        <Item>
          <WsTypography
            bold={true}
            variant={WsTypoVariants.TITLE}
            display="inline"
          >{`Sales By Account Manager`}</WsTypography>
        </Item>
        <Item>
          <YearQuarterDropdown pastYears={10} onDateSelect={(date) => setSelectedDate(date)} />
        </Item>
      </Stack>
      <Box mt={0.5} style={{ height: 670 }}>
        <DataGrid
          columns={columns}
          rows={tableData}
          components={{ Toolbar: GridToolbar }}
          pageSize={paginationSize}
          rowsPerPageOptions={[paginationSize]}
        />
      </Box>
    </Box>
  );
};

export default SalesByAMTable;
